import { Button } from "@/components/Button"
import { Expense3DSPassword } from "@/components/Cards/Create/Expense/3DSPassword"
import { Image } from "@/components/common/Image"
import { Modal } from "@/components/Modal"
import { useCardPassword } from "@usher/pe-client-front-end-lib"
import { useState } from "react"
import { FormProvider } from "react-hook-form"
import { FormattedMessage, useIntl } from "react-intl"

export const CardActionPassword = () => {
  const { $t: t } = useIntl()
  const [open, setOpen] = useState(false)
  const { changePINCode, formMethods } = useCardPassword({
    onSuccess: () => setOpen(false),
  })

  return (
    <>
      <button className="btn-modal" onClick={() => setOpen(true)}>
        <Image src="editing.svg" />
        <FormattedMessage id="change-pin" />
      </button>

      <Modal title={t({ id: "change-pin" })} onClose={() => setOpen(false)} show={open}>
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(changePINCode)} className="w-full sm:min-w-[439px]">
            <Expense3DSPassword withoutPhone control={formMethods.control} />
            <Button type="submit">
              <FormattedMessage id="pa_195" />
            </Button>
          </form>
        </FormProvider>
      </Modal>
    </>
  )
}
